<section id="content">


  <div class="card">
    <div class="card-title">
      <h2>Product Inventory Management</h2>
    </div>
    <div class="product-inventory-container">
      <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
        <p-accordionTab header="Product Inventory table">

          <div class="group-cont">
            <div class="table-responsive">

              <p-table #dtinv class="table" styleClass="ui-table-products" tableStyleClass="table table-responsive"
                [value]="products" totalRecords="{{products.length}}" [rows]="10" [showCurrentPageReport]="true"
                [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true" [resizableColumns]="true"
                (onFilter)="onTableFilter($event)"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                <ng-template pTemplate="caption">
                  <div style="text-align: right">
                    <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                      (click)="exportExcelForInventoy()" style="margin-top: 0.5em;margin-right: 0.5em;"
                      class="ui-button-success"></button>
                    <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                      (click)="exportPdfForInventoy()" label="PDF" class="ui-button-warning"></button>
                  </div>
                </ng-template>
                <ng-template pTemplate="header">
                  <tr>
                    <th>#</th>
                    <th pSortableColumn="productCategory" width="15%">Category
                      <p-sortIcon field="productCategory"></p-sortIcon>
                    </th>
                    <th pSortableColumn="productType" width="15%">Type
                      <p-sortIcon field="productType"></p-sortIcon>
                    </th>
                    <th pSortableColumn="productItem" width="15%">Item
                      <p-sortIcon field="productItem"></p-sortIcon>
                    </th>
                    <th pSortableColumn="customerStock" width="15%">Customer Stocks
                      <p-sortIcon field="customerStock"></p-sortIcon>
                    </th>
                    <!-- <th pSortableColumn="stockCount" width="15%">Stocks Count
                      <p-sortIcon field="stockCount"></p-sortIcon>
                    </th> -->
                    <th pSortableColumn="reservedStock" width="15%">Reserved Stocks
                      <p-sortIcon field="reservedStock"></p-sortIcon>
                    </th>
                    
                    <th pSortableColumn="onHandStock" width="15%">On-hand Stocks
                      <p-sortIcon field="onHandStock"></p-sortIcon>
                    </th>
                    <th pSortableColumn="orderCount" width="15%">Order Count
                      <p-sortIcon field="orderCount"></p-sortIcon>
                    </th>
                    <!-- <th pSortableColumn="stockPiecesCount" width="15%">Stocked Pieces
                      <p-sortIcon field="stockPiecesCount"></p-sortIcon>
                    </th> -->
                    <th pSortableColumn="orderedPieces" width="15%">Ordered Pieces
                      <p-sortIcon field="orderedPieces"></p-sortIcon>
                    </th>
                    <th pSortableColumn="availablePieces" width="15%">Available Pieces
                      <p-sortIcon field="availablePieces"></p-sortIcon>
                    </th>
                    <th pSortableColumn="totalPieces" width="15%">Total Pieces
                      <p-sortIcon field="totalPieces"></p-sortIcon>
                    </th>
                   
                    <th></th>
                  </tr>
                  <tr>
                    <th></th>
                    <th>
                      <p-columnFilter field="productCategory" type="text" display="menu"
                        placeholder="Product Category"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="productType" type="text" display="menu"
                        placeholder="Product Type"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="productItem" type="text" display="menu"
                        placeholder="Product Item"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="customerStock" type="boolean" display="menu" placeholder="Customer Stock" [matchMode]="'equals'" [value]="false"></p-columnFilter>
                    </th>
                    <!-- <th>
                      <p-columnFilter field="stockCount" type="numeric" display="menu"
                        placeholder="Stocks Count"></p-columnFilter>
                    </th> -->
                    <th>
                      <p-columnFilter field="reservedStock" type="numeric" display="menu"
                        placeholder="Reserved Stock"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="onHandStock" type="numeric" display="menu"
                        placeholder="On-hand Stocks"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="orderCount" type="numeric" display="menu"
                        placeholder="Order Count"></p-columnFilter>
                    </th>
                    <!-- <th>
                      <p-columnFilter field="stockPiecesCount" type="numeric" display="menu"
                        placeholder="Stocked Pieces"></p-columnFilter>
                    </th> -->
                    <th>
                      <p-columnFilter field="orderedPieces" type="numeric" display="menu"
                        placeholder="Ordered Pieces"></p-columnFilter>
                    </th>
                   
                    <th>
                      <p-columnFilter field="availablePieces" type="numeric" display="menu"
                        placeholder="Available Pieces"></p-columnFilter>
                    </th>
                    <th>
                      <p-columnFilter field="totalPieces" type="numeric" display="menu"
                        placeholder="Total Pieces"></p-columnFilter>
                    </th>
                    <th></th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-product let-i="rowIndex">
                  <tr>
                    <td>{{i + 1}}</td>
                    <td>{{product.productCategory}}</td>
                    <td>{{product.productType}}</td>
                    <td>{{product.productItem}}</td>
                    <td>
                      <i class="pi" [ngClass]="{'pi-check-circle': product.customerStock, 'pi-times-circle': !product.customerStock}"></i>
                    </td>
                    <!-- <td>{{product.stockCount}}</td> -->
                    <td>{{product.reservedStock}}</td>
                    <td>{{product.onHandStock}}</td>
                    <td>{{product.orderCount}}</td>
                    <!-- <td>{{product.stockPiecesCount}}</td> -->
                    <td>{{product.orderedPieces}}</td>
                    <td>{{product.availablePieces}}</td>

                    <td>{{product.totalPieces}}</td>
                    <td class="options">
                      <ul>
                        <!-- Actions here -->
                      </ul>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>


    <div class="card">
      <div class="card-title">
        <h2>Order Pieces</h2>
      </div>
      <div class="cont" id="chart-Container">
        <p-dropdown [options]="orderPiecesDataTypes" [(ngModel)]="selectedOrderPiecesDataType"
          (onChange)="onOrderPiecesDataTypeChange()" optionLabel="label" optionValue="value">
        </p-dropdown>
        <p-chart height="380px" #barChart type="bar" [data]="barChartData" [options]="barChartOptions"></p-chart>
        <button type="button" (click)="exportBarChartAsImage()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PNG</button>
        <button type="button" (click)="exportBarChartAsPDF()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PDF</button>
      </div>
    </div>



  </div>


  <div class="card">
    <div class="card-title">
      <h2>Orders Statistics</h2>
    </div>
    <div class="product-inventory-container">
      <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
        <p-accordionTab header="Orders Statistics table">

          <div class="group-cont">
            <div class="table-responsive">
                
            <p-table #dtCustomerGroups styleClass="ui-table-products" tableStyleClass="table table-responsive"
            tableStyleClass="table table-responsive" [value]="groupedOrder" totalRecords="{{groupedOrder.length}}"
            [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true"
            [autoLayout]="true" [resizableColumns]="true"
            currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
            (onFilter)="onOrderStatsTableFilter($event)">
            <ng-template pTemplate="caption">
              <div style="text-align: right">
                <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                  (click)="exportOrderStatsExcel()" style="margin-top: 0.5em;margin-right: 0.5em;"
                  class="ui-button-success"></button>
                <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                  (click)="exportOrderStatsPdf()" label="PDF" class="ui-button-warning"></button>
              </div>
            </ng-template>
            <!-- Table Header with Filters -->
            <ng-template pTemplate="header">
              <tr>
                <th>#</th>
                <th pSortableColumn="customerName" width="18%">Customer Name
                  <p-sortIcon field="customerName"></p-sortIcon>
                </th>
                <th pSortableColumn="categoryName" width="18%">Category
                  <p-sortIcon field="categoryName"></p-sortIcon>
                </th>
                <th pSortableColumn="typeName" width="20%">Type
                  <p-sortIcon field="typeName"></p-sortIcon>
                </th>
                <th pSortableColumn="itemName" width="18%">Item
                  <p-sortIcon field="itemName"></p-sortIcon>
                </th>
                <th pSortableColumn="ordersCount" width="15%">Orders Count
                  <p-sortIcon field="ordersCount"></p-sortIcon>
                </th>
                <th pSortableColumn="orderedPieces" width="13%">Ordered Pieces
                  <p-sortIcon field="orderedPieces"></p-sortIcon>
                </th>
                <th pSortableColumn="orderedPrice" width="18%">Ordered Price
                  <p-sortIcon field="orderedPrice"></p-sortIcon>
                </th>
              </tr>

              <tr>
                <th></th>
                <th>
                  <p-columnFilter field="customerName" type="text" display="menu"
                    placeholder="Customer Name"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="categoryName" type="text" display="menu"
                    placeholder="Category"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="typeName" type="text" display="menu" placeholder="Type"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="itemName" type="text" display="menu" placeholder="Item"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="ordersCount" type="numeric" display="menu"
                    placeholder="Total Items"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="orderedPieces" type="numeric" display="menu"
                    placeholder="Ordered Pieces"></p-columnFilter>
                </th>
                <th>
                  <p-columnFilter field="orderedPrice" type="numeric" display="menu"
                    placeholder="Ordered Price"></p-columnFilter>
                </th>
              </tr>
            </ng-template>

            <!-- Table Body -->
            <ng-template pTemplate="body" let-group let-i="rowIndex">
              <tr>
                <td>{{i + 1}}</td>
                <td>{{group.customerName}}</td>
                <td>{{group.categoryName}}</td>
                <td>{{group.typeName}}</td>
                <td>{{group.itemName}}</td>
                <td>{{group.ordersCount}}</td>
                <td>{{group.orderedPieces}}</td>
                <td>{{group.orderedPrice}}</td>

              </tr>
            </ng-template>
          </p-table>
            </div>
          </div>
        </p-accordionTab>
      </p-accordion>
    </div>


    <div class="card">
      <div class="card-title">
        <h2>Orders Statistics Chart</h2>
      </div>
      <div class="cont" id="chart-Container">
        <div class="p-grid"
          style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px;">
          <div class="p-col-6" style="flex: 1; padding: 0 5px;">
            <label for="groupBy">Group By:</label>
            <p-dropdown id="groupBy" [options]="orderStatsGroupByOptions" [(ngModel)]="selectedOrderStatsGroupBy"
              (onChange)="updateOrdersStatisticsChart()" optionLabel="label" optionValue="value">
            </p-dropdown>
          </div>
          <div class="p-col-6" style="flex: 1; padding: 0 5px;">
            <label for="dataType">Data Type:</label>
            <p-dropdown id="dataType" [options]="orderStatsDataTypes" [(ngModel)]="selectedOrderStatsDataType"
              (onChange)="updateOrdersStatisticsChart()" optionLabel="label" optionValue="value">
            </p-dropdown>
          </div>
        </div>
        <p-chart #orderStatsChart type="bar" [data]="orderStatsChartData" [options]="orderStatsChartOptions"
          height="380px"></p-chart>
        <button type="button" (click)="exportOrderStatsChartAsImage()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PNG</button>
        <button type="button" (click)="exportOrderStatsChartAsPDF()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PDF</button>
      </div>
    </div>
    <div class="card">
      <div class="card-title">
        <h2> Total prices for each Customer</h2>
      </div>
      <div class="cont" id="pie-chart-container">
        <p-chart #orderStatsPieChart type="pie" [data]="orderStatsPieChartData" [options]="orderStatsPieChartOptions"
          height="380px"></p-chart>
        <button type="button" (click)="exportChartAsImage()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PNG</button>
        <button type="button" (click)="exportPieChartAsPDF()" class="ui-button-success export-button"
          style="margin-top: 1em;">Export Chart as PDF</button>
      </div>
    </div>


  </div>



   

  
</section>